<!-- MÓDULO CONDICIONES EDITABLE -->
<div class="module condiciones">
  <h2>Condiciones</h2>
  <!-- Si no hay condiciones mostar div.noData -->
  @if (financialConditions.length == 0) {
    <div class="noData">No hay información disponible ejemplo</div>
  } @else {
    <!-- Tabla con condiciones -->

    <!-- Si el estado del paque es Aprobado hay que incluir la clase "readOnly" en el div "customTable condiciones" y hay que omitir los div "cell.acciones"-->

    <div class="customTable condiciones">
      <div class="header">
        <!-- <div class="cell habilitado"></div> -->
        <div class="cell plazo">Plazo</div>
        <div class="cell engancheMin">Enganche <br />mínimo</div>
        <div class="cell engancheMax">Enganche <br />máximo</div>
        <div class="cell interes">Interés <br />nominal</div>
        <!-- <div class="cell tasa">Tasa nominal <br />del seguro</div> -->
        <div class="cell comision">Comisión por<br />apertura</div>
        <div class="cell opcion">Opción de<br />compra</div>
        <div class="cell deposito">Depósito en <br />garantía</div>
        <div class="cell gracia">Períodos <br />de gracia</div>
        <div class="cell acciones"></div>
      </div>

      <!-- Ignorar todas las filas a continuación, solo las inlcuyo para completar la lista en forma estática -->
      @for (item of financialConditions; track financialConditions; let i = $index) {
        <div class="row">
          <!-- <div class="cell habilitado">
        <label class="checkboxWrapper">
          <input [(ngModel)]="item.active" type="checkbox" />
          <span class="checkmark"></span>
        </label>
      </div> -->
          <div class="cell plazo">{{ item.term }}</div>
          <div class="cell engancheMin">{{ item.minDownPaymentPercentage }} %</div>
          <div class="cell engancheMax">{{ item.maxDownPaymentPercentage }} %</div>
          <div class="cell interes">{{ item.nominalRate }}</div>
          <!-- <div class="cell tasa">{{ item.insuranceNominalRate }}</div> -->
          <div class="cell comision">{{ item.openingFeePercentage }}</div>
          <div class="cell opcion">{{ item.purchasePercentage }}</div>
          <!-- <div class="cell incentivo">{{item.paymentIncentive}}</div> -->
          <div class="cell deposito">{{ item.warrantyDepositPercentage }}</div>
          <div class="cell gracia">{{ item.gracePeriod }} meses</div>
          <div class="cell acciones" *ngIf="!isApproved() && canShowActions()">
            <a class="edit" tp="Editar condición" (click)="edit(item)">Editar</a>
            <a class="delete" tp="Eliminar condición" (click)="delete(item)">Eliminar</a>
          </div>
        </div>
      }
    </div>
  }

  <div class="actionsWrapper">
    <button *ngIf="!isApproved() && canShowActions()" class="tertiary" (click)="openModal()">
      <i class="icon"></i> Nueva condición
    </button>
  </div>
</div>

<ng-template #modalTemplate>
  <app-condition-template
    [data]="item"
    [isEdit]="isEdit"
    [financialConditions]="financialConditions"
    [allowCapitalGrace]="allowCapitalGrace"
    [allowInterestGrace]="allowInterestGrace"
    (save)="addCondition($event)"
  ></app-condition-template>
</ng-template>

<ng-template #templateConfirmation>
  <app-template-confirmation
    [title]="title"
    [subtitle]="subtitle"
    [btn1]="btn1"
    [btn2]="btn2"
    (closeModal)="closeModal()"
    (actionBtn2)="deleteModalFinancialCondition()"
  ></app-template-confirmation>
</ng-template>
